export default class CountDown {

    constructor(elementId, expireDate, onComplete) {

        this.htmlEl = document.getElementById(elementId)

        if(!this.htmlEl) {
            return
        }

        this.onComplete = onComplete;

        // calculate the remaining time
        this.timeRemaining = expireDate.getTime() - new Date();

        if(this.timeRemaining <= 0) {
            this.complete()
        } else {
            this.start()
        }

    }

    start() {
        //  setup a timer
        const intervalId = setInterval(() => {

            this.timeRemaining -= 1000;

            if (this.timeRemaining < 0) {
                this.complete();
                clearInterval(intervalId);
            } else {
                this.update();
            }

        }, 1000);
    }

    update() {
        this.htmlEl.querySelector('[data-days]').innerHTML = this.format(this.getDays())
        this.htmlEl.querySelector('[data-hours]').innerHTML = this.format(this.getHours())
        this.htmlEl.querySelector('[data-minutes]').innerHTML = this.format(this.getMinutes())
        this.htmlEl.querySelector('[data-seconds]').innerHTML = this.format(this.getSeconds())
    }

    // Event when countdown hits 0
    complete() {
        if (typeof this.onComplete === 'function') {
            this.onComplete();
        }
    }

    getDays() {
        return Math.floor(this.timeRemaining / 1000 / 60 / 60 / 24);
    }

    getHours() {
        return Math.floor(this.timeRemaining / 1000 / 60 / 60) % 24
    }

    getMinutes() {
        return Math.floor(this.timeRemaining / 1000 / 60) % 60;
    }

    getSeconds() {
        return Math.floor(this.timeRemaining / 1000) % 60
    }

    format(number) {
        return number.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        })
    }

}
